:root {
  --composerTextBlack: #000000;
  --sitePurple: #7b50fc;
  --sitePurpleDark: #5a24fb;
  --composerBlack: #001e2b;
  --siteGrey: #eceff5;
}

.container {
  margin-left: auto;
  margin-right: auto;
  min-height: 100vh;
  max-width: unset;
  padding: 0;

  /* [theme.breakpoints.down('md')] {
      padding: '0 18px';
    }; */
}

.headerOffset {
  padding-top: 62px;
}

.sectionContainer {
  display: flex;
  justify-content: center;
  width: 100%;
  overflow-x: hidden;
}

@media (max-width: 600px) {
  .sectionContainer {
    display: block;
  }
}

.section {
  max-width: 1080px;
  padding: 0 45px;
  margin: 0 auto;
}

@media (max-width: 900px) {
  .section {
    padding: 0 18px;
  }
}

.greyBg {
  background-color: var(--siteGrey);
}

.centerBlock {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 45px;
}

@media (max-width: 900px) {
  .centerBlock {
    padding: 0 18px;
  }
}

.header {
  font-size: 72px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0em;
  color: var(--sitePurple);
  margin: 72px 0 0 0;
}

@media (max-width: 900px) {
  .header {
    font-size: 42px;
  }
}

.headerSmallerWidth {
  width: 900px;
}

@media (max-width: 900px) {
  .headerSmallerWidth {
    width: auto;
  }
}

.description {
  margin: 20px 0 0 0;
  font-size: 25px;
  line-height: 1.3;
  color: var(--composerTextBlack);
}

@media (max-width: 900px) {
  .description {
    font-size: 20px;
  }
}

.centerBlock .narrow {
  max-width: 450px;
}

.centerBlock .medium {
  max-width: 650px;
}

.centerBlock span {
  display: block;
}

.tagLineHeading {
  font-size: 48px;
  font-weight: 700;
  line-height: 1;
  color: var(--composerBlack);
}

@media (max-width: 900px) {
  .tagLineHeading {
    font-size: 36px;
  }

  .centerBlock span {
    display: inline;
  }
}

.tagLineDesc {
  font-size: 25px;
  font-weight: 400;
  color: var(--composerBlack);
  margin: 13px 0 0 0;
}

.centeredMessageHeading {
  text-align: center;
  font-weight: 700;
  font-size: 48px;
  line-height: 1;
  color: var(--composerBlack);
}

@media (max-width: 600px) {
  .centeredMessageHeading {
    text-align: left;
  }
}

.centeredMessageDesc {
  max-width: 615px;
  text-align: left;
  margin: 13px 0px 0 0;
  color: var(--composerTextBlack);
  font-size: 25px;
  line-height: 34px;
  font-weight: 400;
  margin-left: auto;
  margin-right: auto;
}

.maxWidthImg {
  max-width: 100%;
  overflow: auto;
}

.logoGridWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1080px;
}

.logoGrid {
  display: grid;
  grid: auto / repeat(5, minmax(0, 1fr));
  place-items: center;
  row-gap: 32px;
}

@media (max-width: 900px) {
  .logoGrid {
    grid: auto / repeat(2, minmax(0, 1fr));
    column-gap: 32px;
  }

  .logoGrid svg {
    max-width: 150px;
  }
}

.videoShowcase {
  display: flex;
  gap: 24px;
}

@media (max-width: 900px) {
  .videoShowcase {
    flex-direction: column;
  }
}

.videoShowcaseBlock {
  flex: 0 0 50%;
  min-height: 433px;
  position: relative;
}

@media (max-width: 900px) {
  .videoShowcaseBlock {
    min-height: unset;
  }
}

.videoShowcaseBlock video {
  min-width: 770px;
  overflow: hidden;
  display: block;
  border-radius: 20px;
}

.videoOnLeft {
  position: absolute;
  right: 0;
}

@media (max-width: 900px) {
  .videoShowcaseBlock video {
    min-width: unset;
  }

  .videoOnLeft {
    position: unset;
  }
}

.videoShowcase button {
  border-radius: 20px;
  background: none;
  color: var(--composerBlack);
  text-transform: none;
  padding: 12px;
  margin: 0 0 4px 0;
  justify-content: left;
  display: flex;
  width: 100%;
  margin-left: -12px;
  align-items: start;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  text-align: left;
  gap: 12px;
}

.videoShowcase button svg {
  margin-top: 2px;
  color: var(--composerPurpleLight);
}

.videoShowcase b {
  font-weight: 700;
}

.videoShowcase button.active {
  background-color: rgb(0 0 0 / 7%);
}

.videoShowcase button:hover {
  background-color: rgb(0 0 0 / 7%);
}

.videoShowcaseMiniHeading {
  color: var(--composerPurpleLight);
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
}

.videoShowcaseDesc {
  color: var(--composerBlack);
  font-size: 25px;
  line-height: 33px;
  font-weight: 400;
  margin: 10px 10px 20px 0;
}

.featureGrid {
  display: grid;
  grid: auto / repeat(2, 1fr);
  row-gap: 32px;
  column-gap: 32px;
  width: min(1080px, calc(100vw - 90px));
}

.gridTwoCol {
  grid-column: span 2;
}

@media (max-width: 900px) {
  .featureGrid {
    grid: auto / repeat(1, 1fr);
    width: min(1080px, calc(100vw - 36px));
  }

  .gridTwoCol {
    grid-column: 1;
  }
}

.featureBox {
  background-color: var(--siteGrey);
  border-radius: 20px;
  padding: 48px;
  font-size: 20px;
  line-height: 1.3;
  background-size: contain;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.featureBoxBlank {
  background-color: inherit;
}

.featureBoxBlack {
  background-color: black;
}

.ar1 {
  aspect-ratio: 1;
}

.featureTitle {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 6px;
}

.featureTitleSmallWidth {
  width: 45%;
}

@media (max-width: 900px) {
  .featureTitleSmallWidth {
    width: auto;
  }
}

.featureTitleMedlWidth {
  width: 55%;
}

@media (max-width: 600px) {
  .featureTitleMedlWidth {
    width: auto;
  }
}

.featureBox a {
  background-color: rgb(0 0 0 / 5%);
  padding: 6px 18px;
  border-radius: 10px;
  text-transform: none;
  font-size: 16px;
  margin-top: 1em;
  color: var(--composerBlack);
  display: inline-block;
  font-weight: 500;
}

.featureStatBlock {
  aspect-ratio: 6/4;
  display: flex;
  align-items: center;
  justify-content: center;
}

.featureStat {
  font-size: 82px;
  font-weight: 700;
}

@media (max-width: 600px) {
  .featureStat {
    font-size: 75px;
  }
}

.featureStatSubText {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
}

@media (max-width: 600px) {
  .featureBox {
    font-size: 16px;
    padding: 32px;
  }

  .featureTextBottom {
    bottom: 32px;
  }

  .featureTitle {
    font-size: 18px;
  }

  .featureBox a {
    font-size: 14px;
  }
}

.featureBox a:hover {
  background-color: white;
}

.featureBoxDark a {
  background-color: rgb(255 255 255 / 10%);
  color: white;
}

.featureBoxDark a:hover {
  background-color: rgb(255 255 255 / 40%);
}

.homeVideo {
  margin-top: 66px;
  border-radius: 20px;
  box-shadow: 0 3px 15px rgb(0 0 0 / 15%);
}

.scExplore {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/sc-explore-bg%402x.jpg');
}

.reExplore {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-explore-bg%402x.jpg');
  color: white;
}

.csExplore {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/cs-explore-bg%402x.jpg');
  color: white;
}

.apiExplore {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/api-explore-bg%402x.png');
}

.scCreateSpacer {
  aspect-ratio: 1080 / 490;
  margin-bottom: 20px;
}

.scCreate {
  background-size: contain;
  background-position: top center;
  width: 100%;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/sc-create%402x.jpg');
}

.reBuildSpacer {
  aspect-ratio: 1080 / 520;
  margin-bottom: 20px;
}

.reBuild {
  background-size: contain;
  background-position: top center;
  width: 100%;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-build%402x.jpg');
}

.reVastSpacer {
  aspect-ratio: 524 / 377;
  margin-bottom: 20px;
}

.reVast {
  background-size: contain;
  background-position: bottom center;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-vast%402x.png');
}

.reFormatsSpacer {
  aspect-ratio: 524 / 374;
  margin-bottom: 20px;
}

.reFormats {
  background-size: contain;
  background-position: bottom center;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-formats%402x.png');
}

.reKeyPlaysSpacer {
  aspect-ratio: 524 / 315;
  margin-bottom: 80px;
}

.reKeyPlays {
  background-size: contain;
  background-position: bottom center;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-key-plays%402x.jpg');
}

.reSportsMomentsSpacer {
  aspect-ratio: 524 / 309;
  margin-bottom: 20px;
}

.reSportsMoments {
  background-size: contain;
  background-position: bottom center;
  width: 100%;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-sports-moments%402x.jpg');
}

.scSupport {
  background-size: 100%;
  background-position: bottom center;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/sc-support%402x.png');
}

.scSupportSpacer {
  aspect-ratio: 524 / 300;
  margin-top: 40px;
}

.scFillExisting {
  background-size: 100%;
  background-position: bottom center;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/sc-fill-existing%402x.png');
}

.scFillExistingSpacer {
  aspect-ratio: 524 / 323;
  margin-top: 40px;
}

.scKeyMomentsSpacer {
  aspect-ratio: 524 / 329;
  margin-top: 20px;
}

.scKeyMoments {
  background-size: contain;
  background-position: bottom center;
  width: 100%;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/sc-fly-moment%402x.png');
}

.scBrandAff {
  background: linear-gradient(180deg, #63c7ff 0%, #7f40fc 100%);
}

.csPipSpacer {
  aspect-ratio: 1080 / 581;
  margin-bottom: 20px;
}

.csPip {
  background-size: contain;
  background-position: top center;
  width: 100%;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/cs-pip%402x.jpg');
}

.csSqueezeSpacer {
  aspect-ratio: 1080 / 564;
  margin-bottom: 20px;
}

.csSqueeze {
  background-size: contain;
  background-position: top center;
  width: 100%;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/cs-squeeze%402x.jpg');
}

.csOverlaySpacer {
  aspect-ratio: 1080 / 484;
  margin-bottom: 20px;
}

.csOverlay {
  background-size: contain;
  background-position: top center;
  width: 100%;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/cs-overlay%402x.jpg');
}

@media (max-width: 900px) {
  .scAdsSpacer {
    aspect-ratio: 477 / 403;
  }
}

.scAds {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/sc-ads%402x.png');
  background-position: right center;
  background-size: auto 100%;
  min-height: 280px;
}

@media (max-width: 900px) {
  .scAds {
    min-height: unset;
    background-size: 100%;
    background-position: bottom center;
    background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/sc-ads-m%402x.png');
  }
}

.scActionSpacer {
  aspect-ratio: 1080 / 439;
  margin-top: 20px;
}
.scAction {
  background-size: contain;
  background-position: bottom center;
  width: 100%;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/sc-action%402x.png'),
    linear-gradient(180deg, #4e9fff 0%, #243d4e 100%);
}

.scYesCase {
  background: radial-gradient(90.25% 238.67% at 21.26% -52.09%, #906bff 42%, #bfaaff 100%);
}

.reHeader {
  height: 681px;
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  margin-top: 144px;
}

@media (max-width: 600px) {
  .reHeader {
    margin-top: 72px;
  }
}

.reHeaderGrid {
  display: grid;
  grid: auto / repeat(5, 1fr);
  row-gap: 32px;
  column-gap: 32px;
  width: 1957px;
  position: absolute;
}

.reHeaderOffset {
  position: relative;
  left: calc(50% + 16px);
}

.reHeaderImg {
  aspect-ratio: 366 / 205;
  background-color: #eceff5;
  border-radius: 20px;
  background-size: cover;
  box-shadow: 0 2px 15px rgb(0 0 0 / 20%);
}

@media (max-width: 600px) {
  .reHeaderGrid {
    row-gap: 16px;
    column-gap: 16px;
  }

  .reHeaderGrid {
    width: 978px;
  }

  .reHeader {
    height: 340px;
  }

  .reHeaderOffset {
    position: relative;
    left: calc(50% + 8px);
  }

  .reHeaderImg {
    border-radius: 10px;
  }
}

.reHeader1 {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-header-1%402x.jpg');
}

.reHeader2 {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-header-2%402x.jpg');
}

.reHeader3 {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-header-3%402x.jpg');
}

.reHeader4 {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-header-4%402x.jpg');
}

.reHeader5 {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-header-5%402x.jpg');
}

.reHeader6 {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-header-6%402x.jpg');
}

.reHeader7 {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-header-7%402x.jpg');
}

.reHeader8 {
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/re-header-8%402x.jpg');
}

.reHeaderBlank {
  aspect-ratio: 366 / 205;
}

.csHeader {
  height: 715px;
  width: 100%;
  background-image: url('https://dxgcj7vu1u7nu.cloudfront.net/web-assets/cs-header%402x.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 72px;
}

@media (max-width: 600px) {
  .csHeader {
    height: 375px;
    margin-top: 36px;
  }
}

.homeHeaderGrad {
  background: radial-gradient(73.82% 73.82% at 48.26% 4.72%, rgba(135, 95, 255, 0.22) 0%, rgba(135, 95, 255, 0) 100%);
}

.scHeaderGrad {
  background: radial-gradient(73.82% 73.82% at 48.26% 4.72%, rgba(146, 190, 255, 0.25) 0%, rgba(146, 190, 255, 0) 100%);
}

.reHeaderGrad {
  background: radial-gradient(73.82% 73.82% at 48.26% 4.72%, rgba(255, 147, 86, 0.2) 0%, rgba(255, 147, 86, 0) 100%);
}

.csHeaderGrad {
  background: radial-gradient(73.82% 73.82% at 48.26% 4.72%, rgba(255, 146, 231, 0.25) 0%, rgba(255, 146, 231, 0) 100%);
}

.headerVideo {
  position: relative;
  width: min(1080px, calc(100vw - 90px));
}

.headerVideo video {
  border-radius: 20px;
  box-shadow: 0 3px 15px rgb(0 0 0 / 20%);
  width: 95%;
  margin-bottom: 3%;
  background-color: black;
}

@media (max-width: 600px) {
  .headerVideo {
    width: min(1080px, calc(100vw - 36px));
  }

  .headerVideo video {
    border-radius: 10px;
  }
}

.scHeaderOverlay {
  width: 334px;
  height: 386px;
  background-image: url(https://dxgcj7vu1u7nu.cloudfront.net/web-assets/sc-header-overlay%402x.jpg);
  background-size: contain;
  box-shadow: 0 3px 14px rgb(0 0 0 / 10%);
  border-radius: 14px;
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: white;
}

@media (max-width: 900px) {
  .scHeaderOverlay {
    width: 223px;
    height: 257px;
    border-radius: 9px;
  }
}

@media (max-width: 700px) {
  .scHeaderOverlay {
    width: 167px;
    height: 193px;
    border-radius: 7px;
  }
}

@media (max-width: 400px) {
  .scHeaderOverlay {
    width: 134px;
    height: 155px;
    border-radius: 5px;
  }
}

.footer {
  background-color: var(--siteGrey);
  max-width: 1080px;
  margin: 144px auto 0 auto;
  padding: 32px 45px 144px;
}

@media (max-width: 900px) {
  .footer {
    padding: 32px 18px 72px;
  }
}

.footer a {
  color: var(--composerBlack);
}

.footerGrid {
  display: grid;
  grid: auto / repeat(2, 1fr);
  row-gap: 32px;
  column-gap: 32px;
  align-items: start;
}

@media (max-width: 900px) {
  .footerGrid {
    grid: auto / repeat(1, 1fr);
  }
}

.footerLinkGrid {
  display: grid;
  grid: auto / repeat(3, 1fr);
  row-gap: 32px;
  column-gap: 32px;
  margin-bottom: 32px;
}

.footerGridCenter {
  align-items: center;
}

.footerLinkGrid a {
  display: block;
  margin-top: 5px;
}

@media (max-width: 600px) {
  .footerLinkGrid {
    grid: auto / repeat(2, 1fr);
  }
}

.footerLinkGrid b {
  font-weight: 700;
  display: block;
  margin-bottom: 8px;
}

.footerCoryright {
  display: flex;
  align-items: center;
  color: var(--composerBlack);
  font-size: 13px;
  gap: 12px;
  padding-top: 2px;
}

.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
}

.demoModal {
  border-radius: 20px;
  background-color: white;
  box-shadow: 0 4px 12px rgb(0 0 0 / 20%);
  padding: 32px;
}

.demoModal h2 {
  font-size: 24px;
}

.demoModal .inputBlock {
  margin-top: 12px;
}

.secondaryButton {
  text-transform: none;
  border-radius: 10px;
  color: #333;
  background-color: #eaeaea;
  white-space: nowrap;
}

.secondaryButton:hover {
  background-color: #dbdbdb;
}

.keyButton {
  text-transform: none;
  background-color: var(--sitePurple);
  color: white;
  border-radius: 10px;
  white-space: nowrap;
}

.keyButton:hover {
  background-color: var(--sitePurpleDark);
}

.keyButton svg {
  color: white;
}

.menuButton {
  background-color: rgba(0, 0, 0, 0);
  min-width: unset;
  margin-left: 8px;
  border-radius: 10px;
}

.menuButton:hover {
  background-color: rgba(0, 0, 0, 0);
}

.menuButton svg {
  color: var(--composerBlack);
}

.navMenu {
  position: fixed;
  left: 0px;
  top: 60px;
  right: 0;
  bottom: 0;
  background-color: white;
  padding: 18px 45px;
}

@media (max-width: 900px) {
  .navMenu {
    padding: 18px 24px;
  }
}

@media (max-width: 600px) {
  .navMenu {
    padding: 18px;
  }
}

.navMenu .buttonWrap {
  padding-bottom: 18px;
  border-bottom: 1px solid #e5e5e5;
}

.navMenu button {
  width: 100%;
}

.navMenu a {
  display: block;
  padding: 14px 0;
  border-bottom: 1px solid #e5e5e5;
  color: var(--composerBlack);
}

.navMenu a:hover {
  color: var(--sitePurple);
}

.h2 {
  color: var(--composerBlack);
  font-size: 48px;
  line-height: 50px;
  font-weight: 700;
  margin: 12px 0 24px 0;
}

.xHidden {
  overflow-x: hidden;
}

.relative {
  position: relative;
}

.flex {
  display: flex;
}

.gap {
  gap: 12px;
}

.f1 {
  flex: 1;
}

.mt {
  margin-top: 8px;
}

.mt2 {
  margin-top: 16px;
}

.mt3 {
  margin-top: 36px;
}

.mt4 {
  margin-top: 48px;
}

.mt5 {
  margin-top: 60px;
}

.mt6 {
  margin-top: 72px;
}

.mt12 {
  margin-top: 144px;
}

.mb3 {
  margin-bottom: 36px;
}

.mb6 {
  margin-bottom: 72px;
}

.font24 {
  font-size: 24px;
}

.white {
  color: white;
}

.icon {
  font-size: 26px;
  color: var(--sitePurple);
}
